import ClubInfoRoot from './ClubInfoRoot';

export default ClubInfoRoot;
